import { MainLayout } from "@src/component/home/renewal/main/pc/MainLayout";
import { MainFooterMobile } from "../../main/mobile/MainFooterMobile";
import { MainGnbMobile } from "../../main/mobile/MainGnbMobile";
import { ExpertContentsMobile } from "./ExpertContentsMobile";

const ExpertPageMobile = () => (
	<MainLayout>
		<MainGnbMobile type="expert" />
		<ExpertContentsMobile />
		<MainFooterMobile />
	</MainLayout>
);

export default ExpertPageMobile;
